import { TitleController } from '@pandiafi/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import {
  ResidentAppBackLink,
  ResidentAppCard,
  ResidentAppView,
} from '@pandiafi/components'

import { ContractType } from '../../../common/types'
import { NavBar } from './NavBar'

import { useAPIGetContractSuspense } from 'api/apiHooks/useAPIGetContract'
import { useAPIGetContractRightOfOccupancyFee } from 'api/apiHooks/useAPIGetContractRightOfOccupancyFee'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

export const Payments: React.FC = () => {
  const {
    paymentInfoPath,
    paymentHistoryPath,
    rightOfOccupancyFeePath,
    frontPagePath,
  } = useContractPaths()
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: rightOfOccupancyFee, isError: isRightOfOccupancyFeeError } =
    useAPIGetContractRightOfOccupancyFee(
      currentContractId,
      contract.contractType === ContractType.RIGHT_OF_OCCUPANCY
    )
  const { t } = useTranslation(['common', 'payments', 'titles'])

  const paymentRoutes = [
    {
      path: paymentHistoryPath,
      label: t('payments:invoices'),
    },
    {
      path: paymentInfoPath,
      label: t('payments:paymentReferences'),
    },
    ...(rightOfOccupancyFee || isRightOfOccupancyFeeError
      ? [
          {
            path: rightOfOccupancyFeePath,
            label: t('payments:rightOfOccupancyFee.tab'),
          },
        ]
      : []),
  ]

  return (
    <TitleController title={t('titles:paymentInformation')}>
      <ResidentAppView
        title={t('titles:paymentInformation')}
        variant="full"
        backLink={
          <ResidentAppBackLink href={frontPagePath}>
            {t('common:views.home')}
          </ResidentAppBackLink>
        }
      >
        <ResidentAppCard>
          <NavBar routes={paymentRoutes} />
          <Outlet />
        </ResidentAppCard>
      </ResidentAppView>
    </TitleController>
  )
}
